export const ContentPage = {
  esES: {
    language: ['Español', 'Inglés'],
    menu: [
      {
        name: 'Nosotros',
        router: '/nosotros',
      },
      {
        name: 'Productos',
        router: '/productos',
      },
      {
        name: 'Recetas',
        router: '/recetas',
      },
      {
        name: 'Para profesionales de la salud',
        router: '/profesionales/conferencias',
      },
      {
        name: 'Contáctanos',
        router: '/contactanos',
      },
    ],
    banner: [
      {
        background: 'assets/images/banner-1.webp',
        image: '',
        title:
          'Mejora tu calidad de vida y sonríe más junto a tus seres queridos',
        description:
          'Existen datos consistentes de que la suplementación nutricional mejora notablemente el día a día de las personas',
        action: 'Ver productos',
        icons: [],
        redirecto: 1,
      },
      {
        background: 'assets/images/banner-2.webp',
        image: 'assets/images/image-banner-2.webp',
        title: 'Proteína líquida hidrolizada de alta calidad proteica',
        description:
          'Con aminoácidos esenciales, no esenciales y condicionalmente esenciales. Enriquecida con arginina',
        action: 'Ver productos',
        icons: [],
        redirecto: 2,
      },
      {
        background: 'assets/images/banner-2.webp',
        image: 'assets/images/image-banner-3.webp',
        title: 'Proteína líquida hidrolizada de alta calidad proteica',
        description:
          'Con aminoácidos esenciales, no esenciales y condicionalmente esenciales. Enriquecida con arginina, vitamina C,D y zinc',
        action: 'Ver productos',
        icons: [
          'assets/images/icon-1-banner-3.webp',
          'assets/images/icon-2-banner-3.webp',
          'assets/images/icon-3-banner-3.webp',
        ],
        redirecto: 2,
      },
      {
        background: 'assets/images/banner-2.webp',
        image: 'assets/images/image-banner-4.webp',
        title: '',
        description: '',
        action: 'Ver productos',
        icons: [],
        redirecto: 1,
      },
    ],
    titleProductLanding: 'Nuestros productos',
    productsLanding: [
      {
        id: 1,
        bullet: 'assets/svg/carbohidratos-icon.svg',
        title: 'Carbohidratos',
        description:
          'Los carbohidratos son nutrientes los cuales esta imprescindible para el correcto funcionamiento de nuestro organismo.',
        subtitle: 'Algunas de sus principales funciones son:',
        functions: [
          'Producción de energía',
          'Almacenamiento de energía',
          'Conservación de proteínas',
        ],
        action: 'Ver más',
        image: 'assets/images/carbohidratos.webp',
        reverse: false,
      },
      {
        id: 2,
        bullet: 'assets/svg/proteina-icon.svg',
        title: 'Proteínas',
        description:
          'Las proteínas son nutrientes presentes en los alimentos, están formadas por moléculas pequeñas llamadas aminoácidos.',
        subtitle: 'Algunas de sus principales funciones son:',
        functions: [
          'Estructura: Formación de músculos, tejidos, piel, entre otros',
          'Defensa: Mejora el sistema inmunológico',
          'Transporte: Transporte de nutrientes en nuestro organismo.',
        ],
        action: 'Ver más',
        image: 'assets/images/proteina.webp',
        reverse: true,
      },
      {
        id: 3,
        bullet: 'assets/svg/fibra-icon.svg',
        title: 'Fibra',
        description:
          'La fibra soluble es un carbohidrato que forma parte de la alimentación balanceada y saludable.',
        subtitle: 'Algunas de sus principales funciones son:',
        functions: [
          'Absorción de nutrientes',
          'Regula los niveles de glucosa y lípidos en sangre',
          'Brinda sensación de saciedad',
          'Mejora el sistema inmunológico',
          'Mejora el tránsito intestinal',
        ],
        action: 'Ver más',
        image: 'assets/images/fibra.webp',
        reverse: false,
      },
      {
        id: 4,
        bullet: 'assets/svg/grasa-icon.svg',
        title: 'Lípidos',
        description:
          'Las grasas son nutrientes importantes en nuestra alimentación, es importante conocer el tipo de grasas que se consumen.',
        subtitle: 'Los triglicéridos de cadena media son grasas que:',
        functions: [
          'Son fácilmente digeridos y absorbidos',
          'Son fuente de energía rápidamente disponible',
          'Mejora la absorción de vitaminas liposolubles, entre otros beneficios',
        ],
        action: 'Ver más',
        image: 'assets/images/grasa.webp',
        reverse: true,
      },
    ],
    titleSocial: '¡Estamos activos en redes!',
    socialLanding: [
      {
        image: 'assets/images/social-1.webp',
        count: '11',
      },
      {
        image: 'assets/images/social-2.webp',
        count: '08',
      },
      {
        image: 'assets/images/social-3.webp',
        count: '17',
      },
    ],
    footer: {
      logo: 'assets/svg/diutin-footer.svg',
      navigation: [
        {
          icon: 'assets/svg/message.svg',
          title: 'Contáctanos',
          social: [],
          options: [
            {
              name: 'contacto@diutin.com',
              router: '/contactanos',
            },
          ],
        },
        {
          icon: 'assets/svg/mouse.svg',
          title: 'Mapa de sitio',
          social: [],
          options: [
            {
              name: 'Nosotros',
              router: '/nosotros',
            },
            {
              name: 'Productos',
              router: '/productos',
            },
            {
              name: 'Recetas',
              router: '/recetas',
            },
            {
              name: 'Para profesionales de la salud',
              router: '/profesionales/conferencias',
            },
          ],
        },
        {
          icon: 'assets/svg/check.svg',
          title: 'Síguenos en nuestras redes',
          social: [
            {
              icon: 'assets/svg/instagram.svg',
              url: 'https://www.instagram.com/diutinglobal/',
            },
            {
              icon: 'assets/svg/facebook.svg',
              url: 'https://www.facebook.com/DiutinGlobal',
            },
            {
              icon: 'assets/svg/spotify.svg',
              url: 'https://open.spotify.com/playlist/0HI4gB6cG2QKdKacimiLQw',
            }
          ],
          options: [],
        },
      ],
      policy: 'DIUTIN© todos los derechos reservados',
      develop:
        '<span class="fw-light">Diseñado y desarrollado por</span> <span class="fw-semibold">Zeventee</span>',
    },
    products: {
      crumbs: [
        {
          label: 'Productos',
          url: '',
        },
        {
          label: 'Categorías',
          url: '',
        },
        {
          label: 'Carbohidratos',
          url: '',
        },
        {
          label: 'Proteínas',
          url: '',
        },
        {
          label: 'Fibra',
          url: '',
        },
        {
          label: 'Lípidos',
          url: '',
        },
      ],
      general: {
        title: 'Categorías',
        subcategories: ['categorías', 'Calidad'],
        captions: [
          {
            icon: 'assets/svg/like.svg',
            name: '98% Valoraciones',
          },
          {
            icon: 'assets/svg/sale.svg',
            name: '5K ventas mensuales',
          },
        ],
        types: [
          {
            id: 1,
            expand: false,
            icon: 'assets/svg/carb-icon.svg',
            name: 'Carbohidratos',
            subcategories: [],
            products: [
              {
                pageCurrent: 1,
                subcategory: null,
                action: 'Quiero saber más',
                flavor: 'Sabor Neutro',
                background: 'assets/images/background-carb-1.webp',
                image: 'assets/images/product-carb-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Carbs',
                    description:
                      'Diutin Carbs es un módulo de carbohidratos en polvo a base de maltodextrina, obtenido bajo los más altos estándares de calidad.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Carbs brinda un mayor aporte de energía en la dieta. Debido a la alta solubilidad ofrece una mezcla mucho más fácil y homogénea al combinarse con bebidas y fórmulas enterales.',
                      features: [
                        'Sin saborizantes ni edulcorante',
                        'Libre gluten y lactosa',
                        'Sabor neutro',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Carbs puede usarse como complemento de carbohidratos en la dieta en situaciones de ingesta disminuida, en niños, jóvenes, adultos, adultos mayores con necesidades calóricas incrementadas.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: ['Lata x 400 g.', 'Sachet x 6g.'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Carbs puede ser mezclado con alimentos, bebidas habituales y fórmulas enterales a las que no les cambia el sabor. Se puede administrar por vía oral o enteral. No para uso parenteral.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            expand: false,
            icon: 'assets/svg/prot-icon.svg',
            name: 'Proteínas',
            subcategories: [
              {
                label: 'Proteínas líquidas',
                selected: true,
              },
              {
                label: 'Proteínas en polvo',
                selected: false,
              },
            ],
            products: [
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Quiero saber más',
                flavor: 'Sabor Mango',
                background: 'assets/images/background-prot-1.webp',
                image: 'assets/images/product-prot-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Mango',
                    description:
                      'Es un módulo proteico líquido enriquecido con Arginina, elaborado bajo los más altos estándares de calidad.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Protein Mango, posee un perfil completo de aminoácidos esenciales, aminoácidos no esenciales y condicionalmente esenciales. Elaborado a base de dipéptidos de colágeno hidrolizado, enriquecido con arginina y fortificado con triptófano. Es una proteína concentrada, de fácil y rápida absorción. Cada medida de 30 ml contiene 16 g de proteína, 2.5 g de arginina.',
                      features: [
                        'Libre de sacarosa, fructosa, lactosa y gluten',
                        'Endulzado con sucralosa',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Protein Mango, puede usarse como complemento proteico de la dieta en situaciones de baja ingesta proteica, en niñas y niños a partir de 1 año de edad, adultos, adultos mayores y deportistas con requerimientos proteicos aumentados. Indicado para pacientes en pre y postoperatorio, paciente inmunodeprimido, hipoalbuminemia, úlceras por presión, pérdida de masa muscular, sarcopenia, cirrosis, tratamiento con diálisis, quemados y patologías relacionadas con requerimientos proteico incrementado.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: [
                        'Sachet x 30 ml.',
                        'Frasco x 450 ml.',
                        'Frasco x 900 ml.',
                        'Frasco x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Protein Mango, puede ser consumido por vía oral solo, mezclado con agua, bebidas y/o alimentos. Por vía enteral (puede usarse por sonda, pero no como única fuente de nutrición, bajo indicación y supervisión), debe diluirse con agua al 50% o mezclado con otras fórmulas enterales. NO PARA USO PARENTERAL.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Quiero saber más',
                flavor: 'Sabor Sandía',
                background: 'assets/images/background-prot-2.webp',
                image: 'assets/images/product-prot-2.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Sandía',
                    description:
                      'Es un módulo proteico líquido enriquecido con Arginina, elaborado bajo los más altos estándares de calidad.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Protein Sandía, posee un perfil completo de aminoácidos esenciales, aminoácidos no esenciales y condicionalmente esenciales. Elaborado a base de dipéptidos de colágeno hidrolizado, enriquecido con arginina y fortificado con triptófano. Es una proteína concentrada, de fácil y rápida absorción. Cada medida de 30 ml contiene 16 g de proteína, 2.5 g de arginina.',
                      features: [
                        'Libre de sacarosa, fructosa, lactosa y gluten',
                        'Endulzado con sucralosa',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Protein Sandía, puede usarse como complemento proteico de la dieta en situaciones de baja ingesta proteica, en niñas y niños a partir de 1 año de edad, adultos, adultos mayores y deportistas con requerimientos proteicos aumentados. Indicado para pacientes en pre y postoperatorio, paciente inmunodeprimido, hipoalbuminemia, úlceras por presión, pérdida de masa muscular, sarcopenia, cirrosis, tratamiento con diálisis, quemados y patologías relacionadas con requerimientos proteico incrementado.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: [
                        'Sachet x 30 ml.',
                        'Frasco x 450 ml.',
                        'Frasco x 900 ml.',
                        'Frasco x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Protein Sandía puede ser mezclado con alimentos, bebidas habituales y fórmulas enterales a las que no les cambia el sabor. Se puede administrar por vía oral o enteral. No para uso parenteral.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Quiero saber más',
                flavor: 'Sabor Limón',
                background: 'assets/images/background-prot-3.webp',
                image: 'assets/images/product-prot-3.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Plus Limón',
                    description:
                      'Es un módulo proteico líquido enriquecido con Arginina, Vitamina C, Vitamina D y Zinc elaborado bajo los más altos estándares de calidad.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Protein Plus limón, posee un perfil completo de aminoácidos esenciales, aminoácidos no esenciales y condicionalmente esenciales. Elaborado a base de dipéptidos de colágeno hidrolizado, enriquecido con arginina y fortificado con triptófano; además se ha añadido vitamina C, vitamina D y zinc. Es una proteína concentrada, de fácil y rápida absorción. Cada medida de 30 ml contiene 16 g de proteína, 2.5 g de arginina, 180 mg de vitamina C, 500 IU de vitamina D y 10mg de Zinc.',
                      features: [
                        'Libre de sacarosa, fructosa, lactosa y gluten. Endulzado con sucralosa',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Protein Plus Limón, puede usarse como complemento proteico de la dieta en situaciones de baja ingesta proteica, en niñas y niños a partir de 1 año de edad, adultos, adultos mayores y deportistas con requerimientos proteicos aumentados. Indicado para pacientes en pre y postoperatorio, paciente inmunodeprimido, hipoalbuminemia, úlceras por presión, pérdida de masa muscular, sarcopenia, cirrosis, tratamiento con diálisis, quemados y patologías relacionadas con requerimientos proteico incrementado.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: [
                        'Sachet x 30 ml.',
                        'Frasco x 450 ml.',
                        'Frasco x 900 ml.',
                        'Frasco x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Protein Plus Limón, puede ser consumido por vía oral solo, mezclado con agua, bebidas y/o alimentos. Por vía enteral (puede usarse por sonda, pero no como única fuente de nutrición, bajo indicación y supervisión), debe diluirse con agua al 50% o mezclado con otras fórmulas enterales. NO PARA USO PARENTERAL.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Quiero saber más',
                flavor: 'Sabor Naranja',
                background: 'assets/images/background-prot-4.webp',
                image: 'assets/images/product-prot-4.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Plus Naranja',
                    description:
                      'Es un módulo proteico líquido enriquecido con Arginina, Vitamina C, Vitamina D y Zinc elaborado bajo los más altos estándares de calidad.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Protein Plus Naranja, posee un perfil completo de aminoácidos esenciales, aminoácidos no esenciales y condicionalmente esenciales. Elaborado a base de dipéptidos de colágeno hidrolizado, enriquecido con arginina y fortificado con triptófano; además se ha añadido vitamina C, vitamina D y zinc. Es una proteína concentrada, de fácil y rápida absorción. Cada medida de 30 ml contiene 16 g de proteína, 2.5 g de arginina, 180 mg de vitamina C, 500 IU de vitamina D y 10mg de Zinc.',
                      features: [
                        'Libre de sacarosa, fructosa, lactosa y gluten. Endulzado con sucralosa',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Protein Plus Naranja, puede usarse como complemento proteico de la dieta en situaciones de baja ingesta proteica, en niñas y niños a partir de 1 año de edad, adultos, adultos mayores y deportistas con requerimientos proteicos aumentados. Indicado para pacientes en pre y postoperatorio, paciente inmunodeprimido, hipoalbuminemia, úlceras por presión, pérdida de masa muscular, sarcopenia, cirrosis, tratamiento con diálisis, quemados y patologías relacionadas con requerimientos proteico incrementado.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: [
                        'Sachet x 30 ml.',
                        'Frasco x 450 ml.',
                        'Frasco x 900 ml.',
                        'Frasco x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Protein Plus Naranja, puede ser consumido por vía oral solo, mezclado con agua, bebidas y/o alimentos. Por vía enteral (puede usarse por sonda, pero no como única fuente de nutrición, bajo indicación y supervisión), debe diluirse con agua al 50% o mezclado con otras fórmulas enterales. NO PARA USO PARENTERAL.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 2,
                action: 'Quiero saber más',
                flavor: 'Sabor Neutro',
                background: 'assets/images/background-prot-5.webp',
                image: 'assets/images/product-prot-5.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Whey Protein',
                    description:
                      'Es proteína en polvo de alto valor biológico a base de concentrado de suero lácteo.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Whey Protein es proteína en polvo de alto valor biológico a base de concentrado de suero lácteo, el cual, es la fuente proteica con más alto valor biológico (VB 104). Contiene mayor aporte de aminoácidos esenciales, principalmente de cadena ramificada y cisteína, favoreciendo al anabolismo proteico. Debido a la solubilidad de las proteínas lácteas, ofrece una mezcla mucho más fácil y homogénea al combinarse con bebidas y fórmulas enterales. Es de sabor neutro.',
                      features: [],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Whey Protein puede usarse como complemento proteico de la dieta en situaciones de baja ingesta proteica, en niñas y niños, adultos, adultos mayores y en deportistas con requerimientos proteicos aumentados. Indicado para pacientes pre y postoperatorio, pacientes oncológicos, VIH, tratamiento con diálisis, quemados y patologías relacionadas con el incremento de requerimiento proteico. 1 medida, equivale a 6.6g (1medida aporta 6.25g de proteína neta asegurando la absorción de 5g de proteína)',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: ['Lata x 275g', 'Sachet x 6.6g'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Whey Protein, puede ser mezclado con alimentos, bebidas habituales y fórmulas enterales a las que no les cambia el sabor. Se puede administrar por vía oral o enteral. NO PARA USO PARENTERAL',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 2,
                action: 'Quiero saber más',
                flavor: 'Sabor Neutro',
                background: 'assets/images/background-prot-6.webp',
                image: 'assets/images/product-prot-6.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Glutamina',
                    description:
                      'Es un módulo de glutamina en polvo elaborado bajo los más altos estándares de calidad.',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Glutamina, es un módulo de glutamina en polvo elaborado bajo lo más altos estándares de calidad, contiene glutamina de grado farmacéutico y maltodextrina como excipiente, brindándole mayor solubilidad y homogenidad en la mezcla.',
                      features: [
                        'Sin saborizante ni edulcorante',
                        'Libre de sacarosa, fructosa y gluten',
                        'Es de sabor neutro',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Glutamina puede usarse como módulo de glutamina en situaciones que se requiera cubrir demandas incrementadas de dicho aminoácido; en grupos de niñas y niños, adultos, adultos mayores y en deportistas. Indicado para pacientes pre y postoperatorio, pacientes oncológicos, VIH, quemados y patologías relacionadas con el incremento de requerimiento de glutamina. 1 sachet de 15g aporta 10g de Glutamina.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: ['Lata x 300g', 'Sachet x 15g'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin Glutamina, Puede ser mezclado con agua, jugo o alimentos y consumirlo inmediatamente. Se puede administrar por vía oral o enteral. NO PARA USO PARENTERAL.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            expand: false,
            icon: 'assets/svg/fib-icon.svg',
            name: 'Fibra',
            subcategories: [],
            products: [
              {
                pageCurrent: 1,
                subcategory: null,
                action: 'Quiero saber más',
                flavor: 'Sin sabor',
                background: 'assets/images/background-fib-1.webp',
                image: 'assets/images/product-fib-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Fibercel',
                    description:
                      'Es fibra soluble en polvo, producido a partir del almidón de maíz no digerible (almidón resistente).',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin Fibercel, es fibra soluble en polvo, producido a partir del almidón de maíz no digerible (almidón resistente), el cual es fermentado por la microbiota del colon, favoreciendo a la producción de AGCC como el butirato, principal fuente de energía para los colonocitos. La fibra soluble prebiótica tiene un efecto saciante, enlentece el vaciamiento gástrico, mejora el tránsito intestinal y no produce diarreas.',
                      features: [
                        'Sin saborizantes ni edulcorante',
                        'Libre de minerales y preservantes',
                        'Libre de gluten, azúcar y grasas',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin Fibercel puede indicarse para cubrir deficiencias de fibra dietética en la alimentación en niños lactantes, niñas y niños, gestantes, adultos, adultos mayores y en deportistas con requerimientos de fibra aumentados. Personas con diabetes o problemas con el azúcar, dislipidemias, estreñimiento, diarreas y afecciones gastrointestinales.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: ['Lata x 336 g.'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Se sugiere de 2 a 6 dosis en el líquido y volumen de su preferencia. Puede ser mezclado con alimentos, bebidas habituales y fórmulas enterales sin alterar el sabor ni olor de la preparación. Solo mezclar bien hasta disolver.  NO PARA USO PARENTERAL.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            expand: false,
            icon: 'assets/svg/gra-icon.svg',
            name: 'Lípidos',
            subcategories: [],
            products: [
              {
                pageCurrent: 1,
                subcategory: null,
                action: 'Quiero saber más',
                flavor: 'Sabor Coco',
                background: 'assets/images/background-gra-1.webp',
                image: 'assets/images/product-gra-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin MCT',
                    description:
                      'Módulo lipídico de triglicéridos de cadena media a base de aceite de coco',
                    general: {
                      title: 'Descripción General',
                      description:
                        'Diutin MCT, es un módulo lipídico a base de Triglicéridos de Cadena Media (MCT), para reforzar la nutrición balanceada, aportando grasas saludables de fácil y rápida digestión. Diutin MCT, puede utilizarse vía oral y entera.',
                      features: [
                        '100% Triglicéridos de cadena media (ácido caprílico y ácido cáprico)',
                        '100% lípidos de rápida absorción',
                        'Sabor natural',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indicaciones',
                      description:
                        'Diutin MCT puede usarse como complemento lipídico en la dieta en situaciones de necesidades incrementadas o ingesta disminuida, en niñas y niños, adultos, adultos mayores.',
                    },
                    presentation: {
                      title: 'Presentación',
                      features: ['Frasco x 450 ml.', 'Sachet x 15 ml.'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instrucciones de uso',
                      description:
                        'Diutin MCT, puede consumirse directamente o mezclarse con su bebida o comida favorita. Mezcla con líquidos: jugos, batidos, leche, agua, etc. Mezcla con alimentos: cremas, sopa, puré, ensaladas, etc.',
                    },
                    conservation: {
                      title: 'Conservación',
                      description:
                        'Conservar en un lugar seco y en su envase original a una temperatura inferior a 30°C. El producto sellado tiene una duración de 2 años y una vez abierto hasta 3 meses.',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    recipes: {
      crumbs: [
        {
          label: 'Recetas',
          url: '',
        },
        {
          label: 'Categorías',
          url: '',
        },
        {
          label: 'Entradas',
          url: '/recetas',
        },
        {
          label: 'Fondos',
          url: '/recetas',
        },
        {
          label: 'Postres',
          url: '/recetas',
        },
        {
          label: 'Jugos y Bebidas',
          url: '/recetas',
        },
      ],
      types: [
        {
          type: 1,
          selected: 'assets/svg/entrada-selected.svg',
          unselected: 'assets/svg/entrada-unselected.svg',
          name: 'Entradas',
          active: true,
        },
        {
          type: 2,
          selected: 'assets/svg/fondo-selected.svg',
          unselected: 'assets/svg/fondo-unselected.svg',
          name: 'Fondos',
          active: false,
        },
        {
          type: 3,
          selected: 'assets/svg/postres-selected.svg',
          unselected: 'assets/svg/postres-unselected.svg',
          name: 'Postres',
          active: false,
        },
        {
          type: 4,
          selected: 'assets/svg/bebidas-selected.svg',
          unselected: 'assets/svg/bebidas-unselected.svg',
          name: 'Jugos y bebidas',
          active: false,
        },
      ],
      detail: ['Ingredientes', 'Preparación', 'Recetas que pueden interesarte'],
      products: [
        {
          type: 1,
          id: 1,
          image: 'assets/images/background-entrada-1.webp',
          title: 'Aliños con Diutin Protein Plus Limón',
          descripcion:
            'Excelente combinación de ingredientes que realzará tus ensaladas.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '01 porción',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 10 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '1 onza (30ml) de Diutin Protein Limón',
            '3 cucharadas de yogurt griego',
            '1/2 limón',
            '1 cucharada de mostaza',
            '1 cucharada de vinagre blanco',
            'Sal y Pimienta al gusto',
          ],
          preparation:
            'Primero vierte 3 cucharadas de Yogurt griego a un pocillo pequeño, luego 1 cucharada de mostaza, 2 cucharadas de vinagre blanco, pimienta y sal al gusto, seguidamente una medida de Diutin Protein Limón. Disolvemos bien la mezcla hasta dejar sin grumos. Y listo! ya tenemos un aliño sabroso y nutritivo para acompañar nuestro almuerzo.',
        },
        {
          type: 2,
          id: 2,
          image: 'assets/images/background-fondos-1.webp',
          title: 'Puré De Papas Con Diutin Fibercel',
          descripcion:
            'Este exquisito puré de papa es el acompañamiento ideal para tu almuerzo.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 25 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '6 Papas Amarillas',
            '1 Taza de Leche',
            '1 Ramita de Perejil picado finamente',
            '4 medidas de Diutin Fibercel',
            '20 g de mantequilla',
            'Sal al gusto',
          ],
          preparation:
            'Pelamos las papas y cortamos en pedazos medianos. En una olla, colocamos 2 tazas de agua y las papas. Dejamos cocinar a fuego lento por 15 minutos. Una vez sancochadas las papas agregamos la leche, mezclamos y aplastamos el tubérculo. Agregamos sal al gusto, añadimos la mantequilla y las hojas de perejil finamente picadas. Para finalizar agregamos 4 medidas de Diutin Fibercel al puré de papas ¡Listo, es momento de disfrutar!',
        },
        {
          type: 3,
          id: 3,
          image: 'assets/images/background-postres-1.webp',
          title: 'Paletas De Mango',
          descripcion:
            'Estas paletas de mango con Diutin Fibercel te dará la frescura que necesitas.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '12 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 6 hrs.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '1 kg de mango maduro',
            '500 ml. de leche evaporada',
            '40 g de leche en polvo',
            '1 medida de Diutin Fibercel (por paleta)',
            'Molde de paletas',
            'Azúcar al gusto',
          ],
          preparation:
            'Lavamos los mangos, para luego pelarlos y picarlos. Colocamos el mango picado en el vaso de la licuadora, añadimos la leche en polvo y la leche evaporada. Licuamos todo y lo vertemos en los moldes de paletas. Ahora añade una medida de Diutin Fibercel a cada molde de paleta antes de llevar a  congelar por 6 horas. Retiramos de la nevera y de los moldes ¡listo a disfrutar!',
        },
        {
          type: 3,
          id: 4,
          image: 'assets/images/image-recipe.webp',
          title: 'Yogurt Frutado',
          descripcion: 'La combinación perfecta para nutrir y disfrutar.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 7 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '1 onza (30ml) de Diutin Protein Mango',
            '1 taza o 250 ml de Yogurt Natural',
            '30 g de Fresas picada',
            '25 g de Plátano picado',
            '25 g de arándanos',
            'Granola o Frutos Secos',
          ],
          preparation:
            'En un vaso servir unas cucharadas del yogurt natural, añadir granola y colocar las frutas picadas, sellar con otra capa de yogurt y granola. Finalmente, añadir 1 onza(30ml) de Diutin Protein Mango.',
        },
        {
          type: 3,
          id: 5,
          image: 'assets/images/background-postres-3.webp',
          title: 'Charlotte De Fresa Con Diutin Whey Protein',
          descripcion: 'Delicioso postre con Diutin Whey Protein.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 4 hrs.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '50 g de gelatina sabor a fresa',
            '340 g de yogurt griego',
            '300 ml de agua caliente',
            '1 medida de Diutin Whey Protein por vaso',
          ],
          preparation:
            'Añadimos en un bowl la gelatina. Vertemos el agua caliente en el bowl y disolvemos bien. Colocamos en la licuadora el yogurt y la gelatina. Vertemos la mezcla en pyrex y llevamos inmediatamente a refrigerar.',
        },
        {
          type: 3,
          id: 6,
          image: 'assets/images/background-postres-4.webp',
          title: 'Smoothie De Frutas Con Avena Y Diutin Protein Sandía',
          descripcion:
            'Exquisito y nutritivo smoothie de avena con Diutin Protein Sandía.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '02 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 7 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '½ taza de avena',
            '1 y ½ vaso de leche',
            '1 taza de fresas',
            '1/2 plátano en rodajas',
            '1 yogur natural',
            '1 cucharadita de vainilla',
            'Topping: rodajas de fresas, plátano y avena',
            '1 medida de Diutin Protein Sandía',
          ],
          preparation:
            'Lava, pela y corta en trozos todas las frutas. Añade la avena, las frutas y demás ingredientes en la licuadora y mezcla bien, hasta obtener una mezcla homogénea. Sirve en un vaso, añade una medida de Diutin Protein Sandía y bate con una cuchara. Para finalizar agrega los toppings de fresas y un poco de avena en hojuelas.',
        },
        {
          type: 3,
          id: 7,
          image: 'assets/images/background-postres-5.webp',
          title: 'Gelatina De Fresa Con Diutin Protein Sandía',
          descripcion: 'Exquisita frescura en cada cucharada.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 2 hrs.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '1 onza (30ml) de Diutin Protein Sandía por vaso',
            '500 ml Agua hervida',
            '500 ml Agua fría',
            '1 sobre de Gelatina',
          ],
          preparation:
            'Disuelva la gelatina del sobre en 4 tazas (1 litro) de agua hervida. Remueve hasta disolver por completo. Agregue 4 tazas (1 litro) de agua fría y remueva. Vierta en los moldes y finalmente añada una medida de diutin protein a cada vaso',
        },
        {
          type: 3,
          id: 8,
          image: 'assets/images/background-postres-6.webp',
          title: 'Paletas De Fresa Con Diutin Whey Protein',
          descripcion:
            'Anímate a preparar paletas de fresa en casa y refresca tu día.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 2 hrs.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '1 kg de fresas',
            '500 ml. de leche evaporada',
            '40 g de leche en polvo',
            '1 medida de Diutin Whey Protein (por paleta)',
            'Molde de paletas',
            'Azúcar al gusto',
          ],
          preparation:
            'Lavamos las fresas, botamos las hojas y las picamos. Colocamos la fresa picada en el vaso de la licuadora, añadimos la leche en polvo y la leche evaporada. Licuamos todo y lo vertemos en los moldes de paletas. Añadimos una medida de Diutin Whey Protein a cada molde. Llevamos a la nevera por 5 horas y listo ¡Hora de disfrutar!',
        },
        {
          type: 4,
          id: 9,
          image: 'assets/images/background-jugo-1.webp',
          title: 'Chocolate Caliente',
          descripcion:
            'Prepara esta irresistible bebida de chocolate con Diutin Whey Protein.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 7 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '2 latas de leche',
            '3 cdas de cocoa en polvo',
            'Tableta de chocolate',
            '2 tazas de agua',
            '1/2 taza de azúcar',
            '1 bastón de canela',
            '1 clavo de olor',
            '1 medida de Diutin Whey Protein por taza.',
          ],
          preparation:
            'Colocar en una olla: 2 latas de leche, 3 cdas de cocoa en polvo, el agua, el clavo de olor y la canela. Mezclar y llevar al fuego. Hervir durante 5 minutos a fuego medio. Agregar el azúcar y mezclar bien hasta disolver por completo. Apagar el fuego y agregar una tableta de chocolate en trozos. Mezclar bien hasta diluir toda la barra por completo. Colar y servir en una taza. Disfruta de un delicioso chocolate con Diutin Whey Protein.',
        },
        {
          type: 4,
          id: 10,
          image: 'assets/images/background-jugo-2.webp',
          title: 'Batido De Frutas Con Leche Y Diutin Whey Protein',
          descripcion:
            'Nuestro batido de frutas con leche y Diutin Whey Protein te brinda una experiencia cremosa y nutritiva.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '03 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 7 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '2 tazas de fresas',
            '2 plátanos',
            '1 taza de leche',
            '40 g de miel',
            '1 medida de Diutin Whey Protein por vaso',
          ],
          preparation:
            'Lavamos adecuadamente las fresas y los plátanos. Retiramos la cáscara del plátano y las hojas verdes de las fresas. Inmediatamente colocamos todos los ingredientes en la taza de la licuadora y licuamos. Una vez licuado añade una medida de Diutin Whey Protein a tu vaso personal y listo a disfrutar.',
        },
        {
          type: 4,
          id: 11,
          image: 'assets/images/background-jugo-3.webp',
          title: 'Jugo De Frutas Con Diutin Protein Sandía',
          descripcion:
            'Una explosión de sabores naturales para acompañar tu desayuno.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 5 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '100 g de plátano de seda',
            '200 g de piña golden',
            '50 g de manzana',
            '200 g de papaya',
            '1 ½ tazas de agua hervida fría',
            '10 cubos de hielo',
            '1 onza (30ml) de Diutin Protein Sandía',
          ],
          preparation:
            'Primero lavamos todas las frutas. Luego picamos el plátano, la papaya, la piña y la manzana. Vertemos las frutas picadas en la licuadora y añadimos el agua y el hielo. Licuamos hasta obtener una mezcla homogénea. Por último, servimos el jugo de frutas y añadimos una medida de Diutin Protein Sandía por vaso.',
        },
        {
          type: 4,
          id: 12,
          image: 'assets/images/background-jugo-4.webp',
          title: 'Sandwich Agridulce Con Diutin Protein',
          descripcion:
            'Prueba esta nueva combinación irresistible para tu desayuno.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '02 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 7 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '½ taza de pollo deshilachado',
            '½ taza de durazno en dados',
            '5 pecanas picadas',
            '1 Yogurt natural',
            '1 medida de Diutin Protein Mango',
            'sal y pimienta al gusto',
            '(2) Pan integral',
          ],
          preparation:
            'En un bowl mezclar todos los ingredientes hasta formar una mezcla cremosa y luego añadimos sal y pimienta al gusto. Añade una medida de Diutin Protein Mango. Preparamos un sandwich con el pollo previamente preparado.',
        },
        {
          type: 4,
          id: 13,
          image: 'assets/images/background-jugo-5.webp',
          title: 'Jugo De Naranja Con Diutin Protein Plus Naranja',
          descripcion: 'Bebida refrescante y nutritiva para iniciar el día.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '01 porción',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 10 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '3 naranjas',
            '1 vaso personal',
            '1 medida de Diutin Protein Plus Naranja',
            'Miel al gusto',
          ],
          preparation:
            'Lavamos las naranjas, luego las cortamos en dos. Exprimimos las naranjas. Colocamos el jugo de naranja en un vaso personal. Añadimos una medida de 30ml. (16g.) de Diutin Protein Plus sabor Naranja, removemos con una cuchara y ¡Listo!',
        },
        {
          type: 4,
          id: 14,
          image: 'assets/images/background-jugo-6.webp',
          title: 'Malteada De Plátano Con Diutin Protein Mango',
          descripcion:
            'Preparar esta rica malteada de plátano es la fusión perfecta entre lo delicioso y lo saludable.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '02 porciones',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Lista en 30 min.',
            },
          ],
          action: 'Empezar a preparar',
          ingredients: [
            '1 taza de Yogurt griego',
            '1 Plátano',
            '1 1/2 taza de Leche',
            'Canela en polvo',
            '2 cucharadas de Avena',
            '1 Medida de Diutin Protein Mango',
          ],
          preparation:
            'Corta el plátano en trozos y ponlos a congelar. Congelar previamente el yogurt. Una vez tengamos ambos ingredientes congelados vamos a colocarlo en la licuadora. Luego agregamos el yogurt, la leche y las hojuelas de avena. Finalmente sirve en un vaso y añade una medida de Diutin Protein Mango y listo ¡Hora de disfrutar!',
        },
      ],
    },
    nosotros: [
      {
        image: 'assets/images/background-mision.webp',
        icon: 'assets/svg/mision.svg',
        title: 'Misión',
        description:
          'Somos una línea de nutrición clínica especializada, comprometidos en brindar productos de calidad, garantizando confianza y beneficios a profesionales de la salud, consumidores y público en general.',
      },
      {
        image: 'assets/images/background-vision.webp',
        icon: 'assets/svg/vision.svg',
        title: 'Visión',
        description:
          'Ser la línea líder en nutrición clínica especializada de la región, contando con un equipo profesional calificado logrando ofrecer productos y servicios innovadores de acuerdo a sus necesidades, comprometidos a mejorar la calidad de vida de las personas.',
      },
    ],
    contactanos: {
      background: 'assets/images/background-contactus.webp',
      title: 'Contáctate con nosotros',
      description:
        'Complete el formulario y nuestro equipo se comunicará con usted dentro de las 24 horas.',
      email: {
        icon: 'assets/svg/email.svg',
        name: 'contacto@diutin.com',
      },
      textfields: [
        {
          label: 'Nombres y apellidos',
          placeholder: 'Ingrese sus nombres y apellidos',
        },
        {
          label: 'Correo electrónico',
          placeholder: 'Ingrese su correo electrónico',
        },
        {
          label: 'País',
          placeholder: 'Ingrese su país de residencia',
        },
        {
          label: 'Ciudad',
          placeholder: 'Ingrese su ciudad de residencia',
        },
        {
          label: 'Consulta',
          placeholder: 'Ingrese su consulta ...',
        },
        {
          label: 'Teléfono',
          placeholder: 'Ingrese número telefónico',
        },
      ],
      action: 'Enviar consulta',
    },
    health: {
      title: 'Para profesionales de la salud',
      description:
        'Hola, te damos la bienvenida a la sección para Profesionales de la salud, donde encontrarás información orientada a la salud y videos para una mejor comprensión.',
      subtitles: [
        {
          icon: 'assets/svg/info.svg',
          title: 'Datos (Obligatorio)',
          placeholders: [
            'Ingrese su nombre(s)',
            'Ingrese sus apellidos',
            'Ingrese su correo electrónico',
            'Ingrese país de residencia',
            'Ingrese su ciudad de residencia',
          ],
        },
        {
          icon: 'assets/svg/ocupation.svg',
          title: 'Ocupación',
          placeholders: [
            {
              label: 'Médico',
              selected: false,
            },
            {
              label: 'Nutricionista',
              selected: false,
            },
            {
              label: 'Enfermero',
              selected: false,
            },
            {
              label: 'Químico',
              selected: false,
            },
            {
              label: 'Farmaceutico',
              selected: false,
            },
            {
              label: 'Otros',
              selected: false,
            },
          ],
        },
      ],
      terms:
        'Deseo recibir información y actualización de actividades y/o productos relacionadas con Diutin.',
      actions: ['Volver al inicio', 'Guardar información'],
      greetings:
        'Gracias por visitarnos, a la brevedad se contactará un representante.',
      profesional: [
        {
          id: 1,
          title: 'Conferencias virtuales',
          image: 'assets/svg/icon-conferences.svg',
          selected: true,
          color:
            'transparent linear-gradient(258deg, #008FD6B3 0%, #164193 100%) 0% 0% no-repeat padding-box',
          path: 'profesionales/conferencias',
          videos: [
            {
              title: 'Microbiota Intestinal e impacto de diferentes fuentes de fibra soluble',
              nameUser:
                'Dra. Bremer Venero',
              date: '22 de Mayo del 2025',
              url: 'https://player.vimeo.com/video/1092287894?title=0&byline=0&portrait=0',
              selected: true,
              safeUrl: '',
            },
            {
              title: 'Soporte Nutricional en paciente crítico Oncológico',
              nameUser:
                'Dr. Alfredo Díaz Guadalupe, Dr. Cesar Rodriguez Félix, Lic. Claudia Rodriguez',
              date: '05 de Diciembre del 2024',
              url: 'https://player.vimeo.com/video/1070130709?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Cirugía Bariátrica y Soporte Nutricional: Claves para el Éxito a Largo Plazo',
              nameUser:
                'Dr. Idelso Vásquez Llano, Dr. Irvin González Alfaro, Lic. Stefany Díaz Yoshisato',
              date: '24 de Octubre del 2024',
              url: 'https://player.vimeo.com/video/1051968884?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Soporte Nutricional en Pacientes Críticos: Enfoque en Gestantes y Pediátricos',
              nameUser:
                'Dr. Alberto Díaz Seminario, Mg. Rosario Milagros Allcca Sovero',
              date: '25 de Septiembre del 2024',
              url: 'https://player.vimeo.com/video/1051964620?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Las dimensiones de la Nutrición Clínica: Un enfoque integral para la Salud',
              nameUser: 'Lic. Zulema Gallardo Flores, Dra. Saby Mauricio Alza',
              date: '28 de Agosto del 2024',
              url: 'https://player.vimeo.com/video/1051958241?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Actualización en Soporte Nutricional Hospitalario',
              nameUser:
                'Dr. Fernando Pachas Alvarado, Dr. Miguel Izarra Becerra, Lic. Edinson Arévalo Cadillo',
              date: '25 de Julio del 2024',
              url: 'https://player.vimeo.com/video/1051949229?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'El papel de la Microbiota en el Soporte Nutricional: Una mirada integral a la salud',
              nameUser:
                'Dr. Juan Carlos Plácido, Dra. Bremer Venero, Lic. Rosemary Herrera',
              date: '20 de Junio del 2024',
              url: 'https://player.vimeo.com/video/1051936346?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Importancia De Los Lípidos En Soporte Nutricional',
              nameUser:
                'Dr. Angel Jafet Morales Alvarez, Lic. Lizbeth Milla Milla',
              date: '24 de Mayo del 2024',
              url: 'https://player.vimeo.com/video/968115376?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Abordaje Nutricional de la Sarcopenia. Actualización en la práctica clínica',
              nameUser: 'Lic. Marisa Canicoba (Argentina)',
              date: '11 de Setiembre del 2021',
              url: 'https://player.vimeo.com/video/480540430?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Desnutrición y Caquexia',
              nameUser: 'Mg. Ingrid Pérez (Nutricionista)',
              date: '13 de Mayo del 2021',
              url: 'https://player.vimeo.com/video/552084930?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Terapia Nutricional en Diálisis. Nuevos desafíos en Covid 19',
              nameUser: 'Mg. Victoria Chimpén',
              date: '07 de Mayo del 2021',
              url: 'https://player.vimeo.com/video/549324001?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Microbiota Intestinal, el papel de los prebióticos y probióticos en la salud',
              nameUser: 'Dra. Bremer Venero Nazario',
              date: '30 de Abril del 2021',
              url: 'https://player.vimeo.com/video/548108139?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Infección por Covid 19 y Enfermedad Renal. Alcances y Resultados',
              nameUser: 'Dr. Cristian León Rabanal',
              date: '23 de Abril del 2021',
              url: 'https://player.vimeo.com/video/547714301?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Dietoterapia en Cirugía Bariátrica',
              nameUser: 'Lic. Marilyn Espantoso de Fitts',
              date: '16 de Abril del 2021',
              url: 'https://player.vimeo.com/video/544654725?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Fragilidad y Sarcopenia en el adulto mayor: Impacto del Covid 19',
              nameUser: 'Dr. Martín Avila Velásquez',
              date: '19 de Marzo del 2021',
              url: 'https://player.vimeo.com/video/530564029?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Microbiota intestinal y Covid 19: Revisión de la evidencia',
              nameUser: 'Dra. Carmen Pineda',
              date: '12 de Marzo del 2021',
              url: 'https://player.vimeo.com/video/528952529?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Fibrosis Pulmonar: Secuela más frecuente por Covid 19 ¿Cómo intervenir?',
              nameUser: 'Dr. Alfredo Pachas',
              date: '11 de Marzo del 2021',
              url: 'https://player.vimeo.com/video/522525846?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Lecciones aprendidas en la terapéutica del paciente crítico con Covid 19',
              nameUser: 'Dr. Guillermo Contreras',
              date: '26 de Febrero del 2021',
              url: 'https://player.vimeo.com/video/528992091?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Abordaje Nutricional del Paciente Crítico Pediátrico y Adulto con Covid-19',
              nameUser: 'Mg. Jorge Velasco y Lic. José Torres',
              date: '27 de Noviembre del 2020',
              url: 'https://player.vimeo.com/video/495241894?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'VIII Conferencia Dia Mundial Diabetes',
              nameUser:
                'Nut. María Luisa Dextre Jaúregui y Nut.Carolina Castrillón Liñán',
              date: '13 de Noviembre del 2020',
              url: 'https://player.vimeo.com/video/488963308?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Terapia Nutricional en el Paciente Crítico Pediátrico con COVID-19: Experiencias y lecciones aprendidas',
              nameUser: 'Dr. Franklin Mendoza',
              date: '29 de Octubre del 2020',
              url: 'https://player.vimeo.com/video/484823149?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Sindrome de Debilidad Adquirida en UCI, ¿Cómo disminuirlo?',
              nameUser: 'Dr. Humberto Lira',
              date: '22 de Octubre del 2020',
              url: 'https://player.vimeo.com/video/482670406?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Microbiota Intestinal: Implicancias en la salud',
              nameUser: 'Dra. Bremer Venero Nazario',
              date: '09 de Octubre del 2020',
              url: 'https://player.vimeo.com/video/534118931?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Rol de la Microbiota Intestinal en la Inmunidad. Nuevos alcances en tiempos Covid-19',
              nameUser: 'Dr. Juan Carlos Plácido',
              date: '02 de Octubre del 2020',
              url: 'https://player.vimeo.com/video/481024435?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Sistema Inmune y Proteínas. Grandes desafíos en infección por Covid-19',
              nameUser: 'Dr. Juan Carlos Plácido',
              date: '25 de Setiembre del 2020',
              url: 'https://player.vimeo.com/video/479929330?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Nutritrauma ¿Cuál es el impacto en la Terapia Intensiva?',
              nameUser: 'Dr. Humberto Lira',
              date: '11 de Setiembre del 2020',
              url: 'https://player.vimeo.com/video/479935875?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Abordaje Nutricional en pacientes UCI Covid, una mirada antes y después',
              nameUser: 'Dr. Sergio Echenique',
              date: '11 de Setiembre del 2020',
              url: 'https://player.vimeo.com/video/466712350?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
          ],
        },
        {
          id: 1,
          title: 'Conversando sobre salud y nutrición',
          image: 'assets/svg/icon-health.svg',
          selected: false,
          color:
            'transparent linear-gradient(258deg, #E60A1699 0%, #E60A16 100%) 0% 0% no-repeat padding-box',
          path: 'profesionales/salud-nutricion',
        },
      ],
    },
  },
  esEN: {
    language: ['Spanish', 'English'],
    menu: [
      {
        name: 'About us',
        router: '/nosotros',
      },
      {
        name: 'Products',
        router: '/productos',
      },
      {
        name: 'Recipes',
        router: '/recetas',
      },
      {
        name: 'For health professionals',
        router: '/profesionales',
      },
      {
        name: 'Contact us',
        router: '/contactanos',
      },
    ],
    banner: [
      {
        background: 'assets/images/banner-1.webp',
        image: '',
        title:
          'Improve your quality of life and smile more with your loved ones',
        description:
          "There are consistent data that nutritional supplementation significantly improves people's daily lives",
        action: 'Show products',
        icons: [],
        redirecto: 1,
      },
      {
        background: 'assets/images/banner-2.webp',
        image: 'assets/images/image-banner-2.webp',
        title: 'High quality hydrolyzed liquid protein',
        description:
          'With essential, non-essential and conditionally essential amino acids. Enriched with arginine',
        action: 'Show products',
        icons: [],
        redirecto: 2,
      },
      {
        background: 'assets/images/banner-2.webp',
        image: 'assets/images/image-banner-3.webp',
        title: 'High quality hydrolyzed liquid protein',
        description:
          'With essential, non-essential and conditionally essential amino acids. Enriched with arginine, vitamin C,D y zinc',
        action: 'Show products',
        icons: [
          'assets/images/icon-1-banner-3.webp',
          'assets/images/icon-2-banner-3.webp',
          'assets/images/icon-3-banner-3.webp',
        ],
        redirecto: 2,
      },
      {
        background: 'assets/images/banner-2.webp',
        image: 'assets/images/image-banner-4.webp',
        title: '',
        description: '',
        action: 'Show products',
        icons: [],
        redirecto: 1,
      },
    ],
    titleProductLanding: 'Our products',
    productsLanding: [
      {
        id: 1,
        bullet: 'assets/svg/carbohidratos-icon.svg',
        title: 'Carbohydrates',
        description:
          'Carbohydrates are nutrients that are essential for the proper functioning of our body.',
        subtitle: 'Some of its main functions are:',
        functions: [
          'Production of energy',
          'Energy storage',
          'Conservation of proteins',
        ],
        action: 'See more',
        image: 'assets/images/carbohidratos.webp',
        reverse: false,
      },
      {
        id: 2,
        bullet: 'assets/svg/proteina-icon.svg',
        title: 'Proteins',
        description:
          'Proteins are nutrients present in food, they are formed by small molecules called amino acids.',
        subtitle: 'Some of its main functions are:',
        functions: [
          'Structure: Formation of muscles, tissues, skin, among others',
          'Defense: Improves the immune system',
          'Transport: Transport of nutrients in our body.',
        ],
        action: 'See more',
        image: 'assets/images/proteina.webp',
        reverse: true,
      },
      {
        id: 3,
        bullet: 'assets/svg/fibra-icon.svg',
        title: 'Fiber',
        description:
          'Soluble fiber is a carbohydrate that is part of a balanced and healthy diet.',
        subtitle: 'Some of its main functions are:',
        functions: [
          'Absorption of nutrients',
          'Regulates blood glucose and lipid levels',
          'Provides a feeling of satiety',
          'Improves the immune system',
          'Improves intestinal transit',
        ],
        action: 'See more',
        image: 'assets/images/fibra.webp',
        reverse: false,
      },
      {
        id: 4,
        bullet: 'assets/svg/grasa-icon.svg',
        title: 'Lipids',
        description:
          'Fats are important nutrients in our diet, it is important to know the type of fats that are consumed.',
        subtitle: 'Medium chain triglycerides are fats that:',
        functions: [
          'They are easily digested and absorbed',
          'They are a readily available source of energy',
          'Improves the absorption of fat-soluble vitamins, among other benefits',
        ],
        action: 'See more',
        image: 'assets/images/grasa.webp',
        reverse: true,
      },
    ],
    titleSocial: 'We are active on social networks!',
    socialLanding: [
      {
        image: 'assets/images/social-1.webp',
        count: '11',
      },
      {
        image: 'assets/images/social-2.webp',
        count: '08',
      },
      {
        image: 'assets/images/social-3.webp',
        count: '17',
      },
    ],
    footer: {
      logo: 'assets/svg/diutin-footer.svg',
      navigation: [
        {
          icon: 'assets/svg/message.svg',
          title: 'Contact us',
          social: [],
          options: [
            {
              name: 'contacto@diutin.com',
              router: '',
            },
          ],
        },
        {
          icon: 'assets/svg/mouse.svg',
          title: 'Site map',
          social: [],
          options: [
            {
              name: 'About us',
              router: '/nosotros',
            },
            {
              name: 'Products',
              router: '/productos',
            },
            {
              name: 'Recipes',
              router: '/recetas',
            },
            {
              name: 'For health professionals',
              router: '',
            },
          ],
        },
        {
          icon: 'assets/svg/check.svg',
          title: 'Follow us on our networks',
          social: [
            {
              icon: 'assets/svg/instagram.svg',
              url: 'https://www.instagram.com/diutinglobal/',
            },
            {
              icon: 'assets/svg/facebook.svg',
              url: 'https://www.facebook.com/DiutinGlobal',
            },
            {
              icon: 'assets/svg/spotify.svg',
              url: 'https://open.spotify.com/playlist/0HI4gB6cG2QKdKacimiLQw',
            }
          ],
          options: [],
        },
      ],
      policy: 'DIUTIN© all rights reserved',
      develop:
        '<span class="fw-light">Designed and developed by</span> <span class="fw-semibold">Zeventee</span>',
    },
    products: {
      crumbs: [
        {
          label: 'Products',
          url: '',
        },
        {
          label: 'Categories',
          url: '',
        },
        {
          label: 'Carbohydrates',
          url: '',
        },
        {
          label: 'Proteins',
          url: '',
        },
        {
          label: 'Fiber',
          url: '',
        },
        {
          label: 'Lipids',
          url: '',
        },
      ],
      general: {
        title: 'Categories',
        subcategories: ['categories', 'Quality'],
        captions: [
          {
            icon: 'assets/svg/like.svg',
            name: '98% Ratings',
          },
          {
            icon: 'assets/svg/sale.svg',
            name: '5K Monthly Sales',
          },
        ],
        types: [
          {
            id: 1,
            expand: false,
            icon: 'assets/svg/carb-icon.svg',
            name: 'Carbohydrates',
            subcategories: [],
            products: [
              {
                pageCurrent: 1,
                subcategory: null,
                action: 'Learn more',
                flavor: 'Neutral Flavor',
                background: 'assets/images/background-carb-1.webp',
                image: 'assets/images/product-carb-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Carbs',
                    description:
                      'Diutin Carbs is a carbohydrate powder module based on maltodextrin, obtained under the highest quality standards.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Carbs provides a higher supply of energy in the diet. Due to its high solubility, it offers a much easier and homogeneous blend when combined with beverages and enteral formulas.',
                      features: [
                        'No flavorings or sweeteners',
                        'Gluten-free and lactose-free',
                        'Neutral flavor',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Carbs can be used as a carbohydrate supplement in the diet in situations of decreased intake, in children, young people, adults, and the elderly with increased caloric needs.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: ['Lata x 400 g.', 'Sachet x 6g.'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Carbs can be mixed with regular food, beverages, and enteral formulas without changing their taste. It can be administered orally or enterally. Not for parenteral use.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            expand: false,
            icon: 'assets/svg/prot-icon.svg',
            name: 'Proteins',
            subcategories: [
              {
                label: 'Liquid Proteins',
                selected: true,
              },
              {
                label: 'Powder Proteins',
                selected: false,
              },
            ],
            products: [
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Learn more',
                flavor: 'Mango Flavor',
                background: 'assets/images/background-prot-1.webp',
                image: 'assets/images/product-prot-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Mango',
                    description:
                      'It is a liquid protein module enriched with Arginine, made under the highest quality standards.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Protein Mango has a complete profile of essential amino acids, non-essential amino acids, and conditionally essential amino acids. It is made from hydrolyzed collagen dipeptides, enriched with arginine, and fortified with tryptophan. It is a concentrated protein, easy and rapid absorption. Each 30 ml scoop contains 16 g of protein, 2.5 g of arginine.',
                      features: [
                        'Free of sucrose, fructose, lactose, and gluten',
                        'Sweetened with sucralose',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Protein Mango can be used as a protein supplement in the diet in situations of low protein intake, in girls and boys from 1 year of age, adults, the elderly, and athletes with increased protein requirements. Indicated for pre and postoperative patients, immunocompromised patients, hypoalbuminemia, pressure ulcers, muscle mass loss, sarcopenia, cirrhosis, dialysis treatment, burns, and pathologies related to increased protein requirements.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: [
                        'Sachet x 30 ml.',
                        'Bottle x 450 ml.',
                        'Bottle x 900 ml.',
                        'Bottle x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Protein Mango can be consumed orally alone, mixed with water, beverages, and/or food. For enteral administration (can be used through a feeding tube, but not as the sole source of nutrition, under indication and supervision), it should be diluted with water by 50% or mixed with other enteral formulas. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Learn more',
                flavor: 'Watermelon Flavor',
                background: 'assets/images/background-prot-2.webp',
                image: 'assets/images/product-prot-2.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Watermelon',
                    description:
                      'It is a liquid protein module enriched with Arginine, made under the highest quality standards.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Protein Watermelon has a complete profile of essential amino acids, non-essential amino acids, and conditionally essential amino acids. It is made from hydrolyzed collagen dipeptides, enriched with arginine, and fortified with tryptophan. It is a concentrated protein, easy and rapid absorption. Each 30 ml scoop contains 16 g of protein, 2.5 g of arginine.',
                      features: [
                        'Free of sucrose, fructose, lactose, and gluten',
                        'Sweetened with sucralose',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Protein Watermelon can be used as a protein supplement in the diet in situations of low protein intake, in girls and boys from 1 year of age, adults, the elderly, and athletes with increased protein requirements. Indicated for pre and postoperative patients, immunocompromised patients, hypoalbuminemia, pressure ulcers, muscle mass loss, sarcopenia, cirrhosis, dialysis treatment, burns, and pathologies related to increased protein requirements.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: [
                        'Sachet x 30 ml.',
                        'Bottle x 450 ml.',
                        'Bottle x 900 ml.',
                        'Bottle x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Protein Watermelon can be consumed orally alone, mixed with water, beverages, and/or food. For enteral administration (can be used through a feeding tube, but not as the sole source of nutrition, under indication and supervision), it should be diluted with water by 50% or mixed with other enteral formulas. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Learn more',
                flavor: 'Lemon Flavor',
                background: 'assets/images/background-prot-3.webp',
                image: 'assets/images/product-prot-3.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Plus Lemon',
                    description:
                      'It is a liquid protein module enriched with Arginine, Vitamin C, Vitamin D, and Zinc, made under the highest quality standards.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Protein Plus Lemon has a complete profile of essential amino acids, non-essential amino acids, and conditionally essential amino acids. It is made from hydrolyzed collagen dipeptides, enriched with arginine, and fortified with tryptophan; in addition, vitamin C, vitamin D, and zinc have been added. It is a concentrated protein, easy and rapid absorption. Each 30 ml scoop contains 16 g of protein, 2.5 g of arginine, 180 mg of vitamin C, 500 IU of vitamin D, and 10mg of Zinc.',
                      features: [
                        'Free of sucrose, fructose, lactose, and gluten. Sweetened with sucralose',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Protein Plus Lemon can be used as a protein supplement in the diet in situations of low protein intake, in girls and boys from 1 year of age, adults, the elderly, and athletes with increased protein requirements. Indicated for pre and postoperative patients, immunocompromised patients, hypoalbuminemia, pressure ulcers, muscle mass loss, sarcopenia, cirrhosis, dialysis treatment, burns, and pathologies related to increased protein requirements.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: [
                        'Sachet x 30 ml.',
                        'Bottle x 450 ml.',
                        'Bottle x 900 ml.',
                        'Bottle x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Protein Plus Lemon can be consumed orally alone, mixed with water, beverages, and/or food. For enteral administration (can be used through a feeding tube, but not as the sole source of nutrition, under indication and supervision), it should be diluted with water by 50% or mixed with other enteral formulas. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 1,
                action: 'Learn more',
                flavor: 'Orange Flavor',
                background: 'assets/images/background-prot-4.webp',
                image: 'assets/images/product-prot-4.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Protein Plus Orange',
                    description:
                      'It is a liquid protein module enriched with Arginine, Vitamin C, Vitamin D, and Zinc, made under the highest quality standards.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Protein Plus Orange has a complete profile of essential amino acids, non-essential amino acids, and conditionally essential amino acids. It is made from hydrolyzed collagen dipeptides, enriched with arginine, and fortified with tryptophan; in addition, vitamin C, vitamin D, and zinc have been added. It is a concentrated protein, easy and rapid absorption. Each 30 ml scoop contains 16 g of protein, 2.5 g of arginine, 180 mg of vitamin C, 500 IU of vitamin D, and 10mg of Zinc.',
                      features: [
                        'Free of sucrose, fructose, lactose, and gluten. Sweetened with sucralose',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Protein Plus Orange can be used as a protein supplement in the diet in situations of low protein intake, in girls and boys from 1 year of age, adults, the elderly, and athletes with increased protein requirements. Indicated for pre and postoperative patients, immunocompromised patients, hypoalbuminemia, pressure ulcers, muscle mass loss, sarcopenia, cirrhosis, dialysis treatment, burns, and pathologies related to increased protein requirements.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: [
                        'Sachet x 30 ml.',
                        'Bottle x 450 ml.',
                        'Bottle x 900 ml.',
                        'Bottle x 1920 ml.',
                      ],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Protein Plus Orange can be consumed orally alone, mixed with water, beverages, and/or food. For enteral administration (can be used through a feeding tube, but not as the sole source of nutrition, under indication and supervision), it should be diluted with water by 50% or mixed with other enteral formulas. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 2,
                action: 'Learn more',
                flavor: 'Neutral Flavor',
                background: 'assets/images/background-prot-5.webp',
                image: 'assets/images/product-prot-5.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Whey Protein',
                    description:
                      'It is high biological value protein powder based on whey protein concentrate.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Whey Protein is high biological value protein powder based on whey protein concentrate, which is the protein source with the highest biological value (VB 104). It contains a higher supply of essential amino acids, mainly branched-chain and cysteine amino acids, favoring protein anabolism. Due to the solubility of dairy proteins, it offers a much easier and homogeneous mixture when combined with beverages and enteral formulas. It is neutral flavored.',
                      features: [],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Whey Protein can be used as a protein supplement in the diet in situations of low protein intake, in girls and boys, adults, the elderly, and athletes with increased protein requirements. Indicated for pre and postoperative patients, oncology patients, HIV, dialysis treatment, burns, and pathologies related to increased protein requirements. 1 scoop provides 6.6g (1 scoop provides 6.25g of net protein, ensuring the absorption of 5g of protein).',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: ['Can x 275g', 'Sachet x 6.6g'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Whey Protein can be mixed with food, beverages, and enteral formulas without altering the taste or smell of the preparation. It can be administered orally or enterally. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
              {
                pageCurrent: 1,
                subcategory: 2,
                action: 'Learn more',
                flavor: 'Neutral Flavor',
                background: 'assets/images/background-prot-6.webp',
                image: 'assets/images/product-prot-6.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Glutamine',
                    description:
                      'It is a glutamine powder module made under the highest quality standards.',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin Glutamine is a glutamine powder module made under the highest quality standards. It contains pharmaceutical grade glutamine and maltodextrin as an excipient, providing greater solubility and homogeneity in the mixture.',
                      features: [
                        'No flavorings or sweeteners',
                        'Free of sucrose, fructose, and gluten',
                        'Neutral flavor',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Glutamine can be used as a glutamine module in situations that require increased demands for this amino acid; in groups of girls and boys, adults, the elderly, and athletes. Indicated for pre and postoperative patients, oncology patients, HIV, burns, and pathologies related to increased glutamine requirements. 1 sachet of 15g provides 10g of Glutamine.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: ['Can x 300g', 'Sachet x 15g'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Usage Instructions',
                      description:
                        'Diutin Glutamine can be mixed with water, juice, or food and consumed immediately. It can be administered orally or enterally. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years, and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            expand: false,
            icon: 'assets/svg/fib-icon.svg',
            name: 'Fiber',
            subcategories: [],
            products: [
              {
                pageCurrent: 1,
                subcategory: null,
                action: 'Learn more',
                flavor: 'Flavorless',
                background: 'assets/images/background-fib-1.webp',
                image: 'assets/images/product-fib-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin Fibercel',
                    description:
                      'It is a soluble fiber in powder form, produced from indigestible corn starch (resistant starch).',
                    general: {
                      title: 'General Description',
                      description:
                        "Diutin Fibercel is a soluble fiber in powder form, produced from indigestible corn starch (resistant starch), which is fermented by the colon's microbiota, favoring the production of SCFAs like butyrate, the main source of energy for colonocytes. The prebiotic soluble fiber has a satiating effect, slows gastric emptying, improves intestinal transit, and does not cause diarrhea. It also helps regulate glucose and cholesterol levels in the blood. It is flavorless and odorless, allowing it to be mixed with beverages, formulas, and food.",
                      features: [
                        'No flavorings or sweeteners',
                        'Free of minerals and preservatives',
                        'Gluten-free, sugar-free, and fat-free',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin Fibercel can be used to supplement dietary fiber deficiencies in the diet for infants, children, pregnant women, adults, older adults, and athletes with increased fiber requirements. It is indicated for people with diabetes or sugar-related problems, dyslipidemia, constipation, diarrhea, and gastrointestinal conditions.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: ['Can x 336g'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instructions for Use',
                      description:
                        'It is recommended to take 2 to 6 doses in the preferred liquid and volume. It can be mixed with regular beverages, formulas, and enteral feeds without altering the taste or odor of the preparation. Simply mix well until dissolved. NOT FOR PARENTERAL USE.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'Store in a dry place and in its original container at a temperature below 30°C. The sealed product has a shelf life of 2 years, and once opened, it lasts up to 3 months.',
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            expand: false,
            icon: 'assets/svg/gra-icon.svg',
            name: 'Lipids',
            subcategories: [],
            products: [
              {
                pageCurrent: 1,
                subcategory: null,
                action: 'Quiero saber más',
                flavor: 'Coconut Flavor',
                background: 'assets/images/background-gra-1.webp',
                image: 'assets/images/product-gra-1.webp',
                steps: [
                  {
                    pag: 1,
                    title: 'Diutin MCT',
                    description:
                      'Coconut Oil-Based Medium-Chain Triglyceride Lipid Module',
                    general: {
                      title: 'General Description',
                      description:
                        'Diutin MCT is a lipid module based on Medium Chain Triglycerides (MCT), to reinforce balanced nutrition, providing healthy fats that are easy and quickly digestible. Diutin MCT, can be used orally and whole.',
                      features: [
                        '100% Medium Chain Triglycerides (Caprylic Acid and Capric Acid)',
                        '100% fast-absorbing lipids',
                        'Natural Taste',
                      ],
                    },
                  },
                  {
                    pag: 2,
                    indications: {
                      title: 'Indications',
                      description:
                        'Diutin MCT can be used as a lipid supplement in the diet in situations of increased needs or decreased intake, in children, adults, and the elderly.',
                    },
                    presentation: {
                      title: 'Presentation',
                      features: ['Frasco x 450 ml.', 'Sachet x 15 ml.'],
                    },
                  },
                  {
                    pag: 3,
                    instructions: {
                      title: 'Instructions for Use',
                      description:
                        'Diutin MCT, can be consumed directly or mixed with your favorite drink or food. Mix with liquids: juices, smoothies, milk, water, etc. Mix with food: creams, soup, puree, salads, etc.',
                    },
                    conservation: {
                      title: 'Conservation',
                      description:
                        'CStore in a dry place and in its original packaging at a temperature below 30°C. The sealed product lasts for 2 years and up to 3 months once opened.',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    recipes: {
      crumbs: [
        {
          label: 'Recipes',
          url: '',
        },
        {
          label: 'Categories',
          url: '',
        },
        {
          label: 'Appetizers',
          url: '',
        },
        {
          label: 'Main Dishes',
          url: '',
        },
        {
          label: 'Desserts',
          url: '',
        },
        {
          label: 'Juices and Beverages',
          url: '',
        },
      ],
      types: [
        {
          type: 1,
          selected: 'assets/svg/entrada-selected.svg',
          unselected: 'assets/svg/entrada-unselected.svg',
          name: 'Appetizers',
          active: true,
        },
        {
          type: 2,
          selected: 'assets/svg/fondo-selected.svg',
          unselected: 'assets/svg/fondo-unselected.svg',
          name: 'Main Dishes',
          active: false,
        },
        {
          type: 3,
          selected: 'assets/svg/postres-selected.svg',
          unselected: 'assets/svg/postres-unselected.svg',
          name: 'Desserts',
          active: false,
        },
        {
          type: 4,
          selected: 'assets/svg/bebidas-selected.svg',
          unselected: 'assets/svg/bebidas-unselected.svg',
          name: 'Juices and Beverages',
          active: false,
        },
      ],
      detail: ['Ingredients', 'Preparation', 'Recipes You May Like'],
      products: [
        {
          type: 1,
          id: 1,
          image: 'assets/images/background-entrada-1.webp',
          title: 'Dressings with Diutin Protein Plus Lemon',
          descripcion:
            'Excellent combination of ingredients that will enhance your salads.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '01 serving',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 10 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '1 ounce (30ml) of Diutin Protein Lemon',
            '3 tablespoons of Greek yogurt',
            '1/2 lemon',
            '1 tablespoon of mustard',
            '1 tablespoon of white vinegar',
            'Salt and pepper to taste',
          ],
          preparation:
            'First, pour 3 tablespoons of Greek yogurt into a small bowl, then add 1 tablespoon of mustard, 2 tablespoons of white vinegar, pepper, and salt to taste. Next, add a measure of Diutin Protein Lemon to the mixture. Dissolve the mixture well until there are no lumps. And voilà! We now have a tasty and nutritious dressing to accompany our lunch.',
        },
        {
          type: 2,
          id: 2,
          image: 'assets/images/background-fondos-1.webp',
          title: 'Mashed Potatoes with Diutin Fibercel',
          descripcion:
            'This exquisite mashed potato is the ideal accompaniment for your lunch.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 25 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '6 Yellow Potatoes',
            '1 Cup of Milk',
            '1 Sprig of Finely Chopped Parsley',
            '4 measures of Diutin Fibercel',
            '20g of butter',
            'Salt to taste',
          ],
          preparation:
            'Peel the potatoes and cut them into medium-sized pieces. In a pot, add 2 cups of water and the potatoes. Let them cook over low heat for 15 minutes. Once the potatoes are boiled, add the milk, mix, and mash the tubers. Add salt to taste, then add the butter and finely chopped parsley leaves. Finally, add 4 measures of Diutin Fibercel to the mashed potatoes. Voilà, it is time to enjoy!',
        },
        {
          type: 3,
          id: 3,
          image: 'assets/images/background-postres-1.webp',
          title: 'Mango Popsicles',
          descripcion:
            'These mango popsicles with Diutin Fibercel will give you the freshness you need.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '12 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 6 hrs.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '1 kg of ripe mango',
            '500 ml of evaporated milk',
            '40 g of powdered milk',
            '1 measure of Diutin Fibercel (per popsicle)',
            'Popsicle molds',
            'Sugar to taste',
          ],
          preparation:
            'Wash and peel the mangoes, then chop them. Place the chopped mango in the blender along with the powdered milk and evaporated milk. Blend everything and pour the mixture into popsicle molds. Now add one measure of Diutin Fibercel to each popsicle mold before freezing for 6 hours. Remove from the freezer and from the molds. Enjoy!',
        },
        {
          type: 3,
          id: 4,
          image: 'assets/images/image-recipe.webp',
          title: 'Fruity Yogurt',
          descripcion: 'The perfect combination to nourish and enjoy.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 7 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '1 ounce (30ml) of Diutin Protein Mango',
            '1 cup or 250 ml of Natural Yogurt',
            '30g of chopped Strawberries',
            '25g of chopped Banana',
            '25g of Blueberries',
            'Granola or Nuts',
          ],
          preparation:
            'In a glass, serve a few tablespoons of natural yogurt, add granola and place the chopped fruits, then seal with another layer of yogurt and granola. Finally, add 1 ounce (30ml) of Diutin Protein Mango.',
        },
        {
          type: 3,
          id: 5,
          image: 'assets/images/background-postres-3.webp',
          title: 'Strawberry Charlotte with Diutin Whey Protein',
          descripcion: 'Delicious dessert with Diutin Whey Protein.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 4 hrs.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '50g of strawberry-flavored gelatin',
            '340g of Greek yogurt',
            '300ml of hot water',
            '1 measure of Diutin Whey Protein per glass',
          ],
          preparation:
            'Add the gelatin to a bowl. Pour the hot water into the bowl and dissolve it well. Put the yogurt and the gelatin in a blender. Pour the mixture into a Pyrex dish and immediately refrigerate.',
        },
        {
          type: 3,
          id: 6,
          image: 'assets/images/background-postres-4.webp',
          title: 'Fruit Smoothie with Oats and Diutin Protein Watermelon',
          descripcion:
            'Exquisite and nutritious oat smoothie with Diutin Protein Watermelon.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '02 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 7 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '½ cup of oats',
            '1 ½ cups of milk',
            '1 cup of strawberries',
            '1/2 sliced banana',
            '1 natural yogurt',
            '1 teaspoon of vanilla',
            'Toppings: slices of strawberries, banana, and oats',
            '1 measure of Diutin Protein Watermelon',
          ],
          preparation:
            'Wash, peel, and cut all the fruits into pieces. Add the oats, fruits, and other ingredients to the blender and mix well until you get a homogeneous mixture. Serve in a glass, add one measure of Diutin Protein Watermelon and stir with a spoon. Finally, add the toppings of strawberries and a little bit of oat flakes.',
        },
        {
          type: 3,
          id: 7,
          image: 'assets/images/background-postres-5.webp',
          title: 'Strawberry Gelatin with Diutin Protein Watermelon',
          descripcion: 'Exquisite freshness in every spoonful.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 2 hrs.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '1 ounce (30ml) of Diutin Protein Watermelon per glass',
            '500ml of boiled water',
            '500ml of cold water',
            '1 packet of Gelatin',
          ],
          preparation:
            'Dissolve the gelatin from the packet in 4 cups (1 liter) of boiled water. Stir until completely dissolved. Add 4 cups (1 liter) of cold water and stir. Pour into molds and finally add one measure of Diutin Protein Watermelon to each glass.',
        },
        {
          type: 3,
          id: 8,
          image: 'assets/images/background-postres-6.webp',
          title: 'Strawberry Popsicles with Diutin Whey Protein',
          descripcion:
            'Go ahead and prepare strawberry popsicles at home and refresh your day.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 2 hrs.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '1kg of strawberries',
            '500ml of evaporated milk',
            '40g of powdered milk',
            '1 measure of Diutin Whey Protein (per popsicle)',
            'Popsicle mold',
            'Sugar to taste',
          ],
          preparation:
            'Wash the strawberries, remove the leaves, and chop them. Put the chopped strawberries in the blender, add the powdered milk and the evaporated milk. Blend everything and pour it into the popsicle molds. Add one measure of Diutin Whey Protein to each mold. Refrigerate for 5 hours, and they are ready to enjoy!',
        },
        {
          type: 4,
          id: 9,
          image: 'assets/images/background-jugo-1.webp',
          title: 'Hot Chocolate',
          descripcion:
            'Prepare this irresistible chocolate drink with Diutin Whey Protein.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 7 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '2 cans of milk',
            '3 tablespoons of cocoa powder',
            'Chocolate bar',
            '2 cups of water',
            '1/2 cup of sugar',
            '1 cinnamon stick',
            '1 clove',
            '1 measure of Diutin Whey Protein per cup',
          ],
          preparation:
            'In a pot, add 2 cans of milk, 3 tablespoons of cocoa powder, water, clove, and cinnamon stick. Mix and bring to a boil over medium heat. Boil for 5 minutes. Add the sugar and mix well until completely dissolved. Turn off the heat and add a chocolate bar in pieces. Mix well until the bar is completely dissolved. Strain and serve in a cup. Enjoy a delicious chocolate with Diutin Whey Protein.',
        },
        {
          type: 4,
          id: 10,
          image: 'assets/images/background-jugo-2.webp',
          title: 'Fruit Shake with Milk and Diutin Whey Protein',
          descripcion:
            'Our fruit shake with milk and Diutin Whey Protein gives you a creamy and nutritious experience.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '03 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 7 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '2 cups of strawberries',
            '2 bananas',
            '1 cup of milk',
            '40g of honey',
            '1 measure of Diutin Whey Protein per glass',
          ],
          preparation:
            "Thoroughly wash the strawberries and bananas. Remove the banana peel and the green leaves from the strawberries. Immediately place all the ingredients in the blender and blend. Once blended, add one measure of Diutin Whey Protein to your personal glass, and you're ready to enjoy!",
        },
        {
          type: 4,
          id: 11,
          image: 'assets/images/background-jugo-3.webp',
          title: 'Fruit Juice with Diutin Protein Watermelon',
          descripcion:
            'An explosion of natural flavors to accompany your breakfast.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '04 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 5 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '100g of silk banana',
            '200g of golden pineapple',
            '50g of apple',
            '200g of papaya',
            '1 ½ cups of cold boiled water',
            '10 ice cubes',
            '1 ounce (30ml) of Diutin Protein Watermelon',
          ],
          preparation:
            'First, wash all the fruits. Then, chop the banana, papaya, pineapple, and apple. Pour the chopped fruits into the blender and add water and ice. Blend until you get a homogeneous mixture. Finally, serve the fruit juice and add one measure of Diutin Protein Watermelon per glass.',
        },
        {
          type: 4,
          id: 12,
          image: 'assets/images/background-jugo-4.webp',
          title: 'Sweet and Sour Sandwich with Diutin Protein',
          descripcion:
            'Try this irresistible new combination for your breakfast.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '02 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 7 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '½ cup of shredded chicken',
            '½ cup of diced peach',
            '5 chopped pecans',
            '1 natural yogurt',
            '1 measure of Diutin Protein Mango',
            'Salt and pepper to taste',
            '2 slices of whole-grain bread',
          ],
          preparation:
            'In a bowl, mix all the ingredients until you get a creamy mixture, then add salt and pepper to taste. Add one measure of Diutin Protein Mango. Prepare a sandwich with the previously prepared chicken mixture.',
        },
        {
          type: 4,
          id: 13,
          image: 'assets/images/background-jugo-5.webp',
          title: 'Orange Juice with Diutin Protein Plus Orange',
          descripcion: 'Refreshing and nutritious drink to start the day.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '01 serving',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 10 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '3 oranges',
            '1 personal glass',
            '1 measure of Diutin Protein Plus Orange',
            'Honey to taste',
          ],
          preparation:
            "Wash the oranges, then cut them in half. Squeeze the oranges and pour the orange juice into a personal glass. Add one measure of 30ml. (16g.) of Diutin Protein Plus in orange flavor, stir with a spoon, and it's ready!",
        },
        {
          type: 4,
          id: 14,
          image: 'assets/images/background-jugo-6.webp',
          title: 'Banana Smoothie with Diutin Protein Mango',
          descripcion:
            'Preparing this rich banana milkshake is the perfect fusion between the delicious and the healthy.',
          bullets: [
            {
              icon: 'assets/svg/people.svg',
              name: '02 servings',
            },
            {
              icon: 'assets/svg/time.svg',
              name: 'Ready in 30 min.',
            },
          ],
          action: 'Start preparing',
          ingredients: [
            '1 cup of Greek Yogurt',
            '1 Banana',
            '1 1/2 cups of Milk',
            'Cinnamon powder',
            '2 tablespoons of Oats',
            '1 measure of Diutin Protein Mango',
          ],
          preparation:
            "Cut the banana into pieces and freeze them. Pre-freeze the yogurt. Once we have both ingredients frozen, place them in the blender. Then add the yogurt, milk, and oat flakes. Finally, serve in a glass and add one measure of Diutin Protein Mango, and you're ready to enjoy!",
        },
      ],
    },
    nosotros: [
      {
        image: 'assets/images/background-mision.webp',
        icon: 'assets/svg/mision.svg',
        title: 'Mission',
        description:
          'We are a specialized clinical nutrition line, committed to providing quality products, ensuring trust and benefits to healthcare professionals, consumers, and the general public.',
      },
      {
        image: 'assets/images/background-vision.webp',
        icon: 'assets/svg/vision.svg',
        title: 'Vision',
        description:
          'To be the leading specialized clinical nutrition line in the region, with a qualified professional team, offering innovative products and services tailored to their needs, committed to improving the quality of life for people.',
      },
    ],
    contactanos: {
      background: 'assets/images/background-contactus.webp',
      title: 'Contact Us',
      description:
        'Fill out the form, and our team will get in touch with you within 24 hours.',
      email: {
        icon: 'assets/svg/email.svg',
        name: 'contact@diutin.com',
      },
      textfields: [
        {
          label: 'Full Name',
          placeholder: 'Enter your full name',
        },
        {
          label: 'Email',
          placeholder: 'Enter your email address',
        },
        {
          label: 'Country',
          placeholder: 'Enter your country of residence',
        },
        {
          label: 'City',
          placeholder: 'Enter your city of residence',
        },
        {
          label: 'Consult',
          placeholder: 'Enter your consult...',
        },
        {
          label: 'Phone',
          placeholder: 'Enter your phone',
        },
      ],
      action: 'Send consult',
    },
    health: {
      title: 'For health professionals',
      description:
        'Hello, we welcome you to the section for Health Professionals, where you will find health-oriented information and videos for a better understanding.',
      subtitles: [
        {
          icon: 'assets/svg/info.svg',
          title: 'Data (Required)',
          placeholders: [
            'Enter your name(s)',
            'Enter your last name',
            'Enter your email',
            'Enter country of residence',
            'Enter your city of residence',
          ],
        },
        {
          icon: 'assets/svg/ocupation.svg',
          title: 'Occupation',
          placeholders: [
            {
              label: 'Doctor',
              selected: false,
            },
            {
              label: 'Nutritionist',
              selected: false,
            },
            {
              label: 'Nurse',
              selected: false,
            },
            {
              label: 'Chemical',
              selected: false,
            },
            {
              label: 'Pharmacist',
              selected: false,
            },
            {
              label: 'Others',
              selected: false,
            },
          ],
        },
      ],
      terms:
        'I wish to receive information and updates on activities and/or products related to Diutin.',
      actions: ['Back to start', 'Save information'],
      greetings:
        'Thank you for visiting us, a representative will contact you shortly.',
      profesional: [
        {
          id: 1,
          title: 'Virtual Conferences',
          image: 'assets/svg/icon-conferences.svg',
          selected: true,
          color:
            'transparent linear-gradient(258deg, #008FD6B3 0%, #164193 100%) 0% 0% no-repeat padding-box',
          path: 'profesionales/conferencias',
          videos: [
            {
              title: 'Intestinal Microbiota and Impact of Different Sources of Soluble Fiber',
              nameUser:
                'Dra. Bremer Venero',
              date: 'May 25, 2025',
              url: 'https://player.vimeo.com/video/1092287894?title=0&byline=0&portrait=0',
              selected: true,
              safeUrl: '',
            },
            {
              title:
                'Nutritional Support in the Critically Ill Oncology Patient',
              nameUser:
                'Dr. Alfredo Díaz Guadalupe, Dr. Cesar Rodriguez Félix, Lic. Claudia Rodriguez',
              date: 'December 5, 2024',
              url: 'https://player.vimeo.com/video/1070130709?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Bariatric Surgery and Nutritional Support: Keys to Long-Term Success',
              nameUser:
                'Dr. Idelso Vásquez Llano, Dr. Irvin González Alfaro, Lic. Stefany Díaz Yoshisato',
              date: 'October 24, 2024',
              url: 'https://player.vimeo.com/video/1051968884?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Nutritional Support in Critically Ill Patients: Focus on Pregnant Women and Pediatrics',
              nameUser:
                'Dr. Alberto Díaz Seminario, Mg. Rosario Milagros Allcca Sovero',
              date: 'September 25, 2024',
              url: 'https://player.vimeo.com/video/1051964620?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'The Dimensions of Clinical Nutrition: A Comprehensive Approach to Health',
              nameUser: 'Lic. Zulema Gallardo Flores, Dr. Saby Mauricio Alza',
              date: 'August 28, 2024',
              url: 'https://player.vimeo.com/video/1051958241?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Update on Hospital Nutritional Support',
              nameUser:
                'Dr. Fernando Pachas Alvarado, Dr. Miguel Izarra Becerra, Lic. Edinson Arévalo Cadillo',
              date: 'July 25, 2024',
              url: 'https://player.vimeo.com/video/1051949229?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'The Role of the Microbiota in Nutritional Support: A Holistic View of Health',
              nameUser:
                'Dr. Juan Carlos Plácido, Dr. Bremer Venero, Lic. Rosemary Herrera',
              date: 'June 20, 2024',
              url: 'https://player.vimeo.com/video/1051936346?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Importance of Lipids in Nutritional Support',
              nameUser:
                'Dr. Angel Jafet Morales Alvarez, Lic. Lizbeth Milla Milla',
              date: 'May 24, 2024',
              url: 'https://player.vimeo.com/video/968115376?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Nutritional Approach to Sarcopenia: Clinical Practice Update',
              nameUser: 'Lic. Marisa Canicoba (Argentina)',
              date: 'September 11, 2021',
              url: 'https://player.vimeo.com/video/480540430?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Malnutrition and Cachexia',
              nameUser: 'Mg. Ingrid Pérez (Nutritionist)',
              date: 'May 13, 2021',
              url: 'https://player.vimeo.com/video/552084930?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Nutritional Therapy in Dialysis: New Challenges in COVID-19',
              nameUser: 'Mg. Victoria Chimpén',
              date: 'May 07, 2021',
              url: 'https://player.vimeo.com/video/549324001?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Intestinal Microbiota: The Role of Prebiotics and Probiotics in Health',
              nameUser: 'Dr. Bremer Venero Nazario',
              date: 'April 30, 2021',
              url: 'https://player.vimeo.com/video/548108139?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Covid-19 Infection and Kidney Disease: Scope and Outcomes',
              nameUser: 'Dr. Cristian León Rabanal',
              date: 'April 23, 2021',
              url: 'https://player.vimeo.com/video/547714301?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Diet Therapy in Bariatric Surgery',
              nameUser: 'Lic. Marilyn Espantoso de Fitts',
              date: 'April 16, 2021',
              url: 'https://player.vimeo.com/video/544654725?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Frailty and Sarcopenia in the Elderly: Impact of Covid-19',
              nameUser: 'Dr. Martín Avila Velásquez',
              date: 'March 19, 2021',
              url: 'https://player.vimeo.com/video/530564029?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Gut Microbiota and Covid-19: Review of the Evidence',
              nameUser: 'Dra. Carmen Pineda',
              date: 'March 12, 2021',
              url: 'https://player.vimeo.com/video/528952529?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Pulmonary Fibrosis: Most Common Sequelae of Covid-19 – How to Intervene?',
              nameUser: 'Dr. Alfredo Pachas',
              date: 'March 11, 2021',
              url: 'https://player.vimeo.com/video/522525846?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Lessons Learned in the Treatment of Critically Ill Covid-19 Patients',
              nameUser: 'Dr. Guillermo Contreras',
              date: 'February 26, 2021',
              url: 'https://player.vimeo.com/video/528992091?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Nutritional Approach for Critical Pediatric and Adult Covid-19 Patients',
              nameUser: 'Mg. Jorge Velasco y Lic. José Torres',
              date: 'November 27, 2020',
              url: 'https://player.vimeo.com/video/495241894?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: '8th Conference – World Diabetes Day',
              nameUser:
                'Nut. María Luisa Dextre Jaúregui y Nut.Carolina Castrillón Liñán',
              date: 'November 13, 2020',
              url: 'https://player.vimeo.com/video/488963308?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Nutritional Therapy in Critical Pediatric Covid-19 Patients: Experiences and Lessons Learned',
              nameUser: 'Dr. Franklin Mendoza',
              date: 'October 29, 2020',
              url: 'https://player.vimeo.com/video/484823149?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'ICU-Acquired Weakness Syndrome – How to Reduce It?',
              nameUser: 'Dr. Humberto Lira',
              date: 'October 22, 2020',
              url: 'https://player.vimeo.com/video/482670406?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Gut Microbiota: Health Implications',
              nameUser: 'Dra. Bremer Venero Nazario',
              date: 'October 9, 2020',
              url: 'https://player.vimeo.com/video/534118931?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Role of Gut Microbiota in Immunity – New Insights During Covid-19 Times',
              nameUser: 'Dr. Juan Carlos Plácido',
              date: 'October 2, 2020',
              url: 'https://player.vimeo.com/video/481024435?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Immune System and Proteins: Major Challenges in COVID-19 Infection',
              nameUser: 'Dr. Juan Carlos Plácido',
              date: 'September 25, 2020',
              url: 'https://player.vimeo.com/video/479929330?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title: 'Nutritrauma – What Is the Impact in Intensive Therapy?',
              nameUser: 'Dr. Humberto Lira',
              date: 'September 11, 2020',
              url: 'https://player.vimeo.com/video/479935875?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
            {
              title:
                'Nutritional Approach in ICU Covid Patients – A View Before and After',
              nameUser: 'Dr. Sergio Echenique',
              date: 'September 11, 2020',
              url: 'https://player.vimeo.com/video/466712350?title=0&byline=0&portrait=0',
              selected: false,
              safeUrl: '',
            },
          ],
        },
        {
          id: 1,
          title: 'Talking About Health and Nutrition',
          image: 'assets/svg/icon-health.svg',
          selected: false,
          color:
            'transparent linear-gradient(258deg, #E60A1699 0%, #E60A16 100%) 0% 0% no-repeat padding-box',
          path: 'profesionales/salud-nutricion',
        }
      ],
    },
  },
};
